module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/artillery-battalion-lvl3-50.202610c8.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/artillery-battalion-lvl3-50.png
// module id = 3503
// module chunks = 11